<div layout="column" class="iwg-dashboard-panel md-whiteframe-z2">
    <div class="iwg-dashboard-panel-photo"
    [ngStyle]="{'background-image': 'url(' + feature.properties.image + ')'}"></div>
        <div class="iwg-dashboard-panel-block">
            <div class="iwg-value">
                {{feature.properties.state ? feature.properties.state + ", USA" : feature.properties.country}}
            </div>
            <div class="iwg-label">
                {{feature.properties.state ? "State" : "Country"}}
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="iwg-dashboard-panel-block">
            <div layout class="dash-detail-block">
                <div class="iwg-label dash-flex-auto" flex>
                    {{feature.properties.assignmentLabel}}
                </div>
                <div class="iwg-value dash-flex-auto text-right">
                    {{feature.properties.workerCount}}
                </div>
            </div>
            <div layout *ngIf="feature.properties.ServiceTypeID != 3" class="dash-detail-block">
                <div class="iwg-label dash-flex-auto" flex >
                    Billing
                </div>
                <div class="iwg-value dash-flex-auto text-right">
                    {{feature.properties.billing}} {{feature.properties.EntityCurrencyCode}}
                </div>
            </div>
            <div layout  *ngIf="feature.properties.ServiceTypeID == 3" class="dash-detail-block">
                <div class="iwg-label dash-flex-auto" flex>
                    Pass
                </div>
                <div class="iwg-value dash-flex-auto text-right">
                    {{feature.properties.pass}}
                </div>
            </div>
            <div layout *ngIf="feature.properties.ServiceTypeID == 3" class="dash-detail-block">
                <div class="iwg-label dash-flex-auto" flex>
                    No Pass
                </div>
                <div class="iwg-value dash-flex-auto text-right">
                    {{feature.properties.nopass}}
                </div>
            </div>

            <div layout *ngIf="feature.properties.totalHours  && feature.properties.ServiceTypeID == 1" class="dash-detail-block">
                <div class="iwg-label dash-flex-auto" flex>
                    Total Hours
                </div>
                <div class="iwg-value dash-flex-auto text-right">
                    {{feature.properties.totalHours}}
                </div>
            </div>
            <div layout *ngIf="feature.properties.regularHours && feature.properties.ServiceTypeID == 1" class="dash-detail-block">
                <div class="iwg-label dash-flex-auto" flex>
                    Regular Hours
                </div>
                <div class="iwg-value dash-flex-auto text-right">
                    {{feature.properties.regularHours}}
                </div>
            </div>
            <div layout *ngIf="feature.properties.overtimeHours && feature.properties.ServiceTypeID == 1" class="dash-detail-block">
                <div class="iwg-label dash-flex-auto" flex>
                    Overtime Hours
                </div>
                <div class="iwg-value dash-flex-auto text-right">
                    {{feature.properties.overtimeHours}}
                </div>
            </div>
            <div layout *ngIf="feature.properties.doubletimeHours && feature.properties.ServiceTypeID == 1" class="dash-detail-block">
                <div class="iwg-label dash-flex-auto" flex>
                    Doubletime Hours
                </div>
                <div class="iwg-value dash-flex-auto text-right">
                    {{feature.properties.doubletimeHours}}
                </div>
            </div>
            <div layout *ngIf="feature.properties.expenses && feature.properties.ServiceTypeID == 1" class="dash-detail-block">
                <div class="iwg-label dash-flex-auto" flex>
                    Expenses
                </div>
                <div class="iwg-value dash-flex-auto text-right">
                    {{feature.properties.expenses}} {{feature.properties.EntityCurrencyCode}}
                </div>
            </div>
        </div>
</div>
